import aMajorPiano from './aMajorPiano.mp3';
import bMajorPiano from './bMajorPiano.mp3';
import cMajorPiano from './cMajorPiano.mp3';
import cMajorPiano2 from './cMajorPiano2.mp3';
import dMajorPiano from './dMajorPiano.mp3';
import eMajorPiano from './eMajorPiano.mp3';
import fMajorPiano from './fMajorPiano.mp3';
import gMajorPiano from './gMajorPiano.mp3';

const notes = [
  { sound: cMajorPiano, label: 'C', note: 'c4' },
  { sound: dMajorPiano, label: 'D', note: 'd4' },
  { sound: eMajorPiano, label: 'E', note: 'e4' },
  { sound: fMajorPiano, label: 'F', note: 'f4' },
  { sound: gMajorPiano, label: 'G', note: 'g4' },
  { sound: aMajorPiano, label: 'A', note: 'a4' },
  { sound: bMajorPiano, label: 'B', note: 'b4' },
  { sound: cMajorPiano2, label: 'C', note: 'c5' },
];

export { notes };